import { InjectionToken } from '@angular/core';

export type StorageFileUrlGetterFn = (id: string) => string;

export const FULL_STORAGE_URL = new InjectionToken<StorageFileUrlGetterFn>('FULL_STORAGE_URL');
export const STORAGE_FILE_URL_GETTER = new InjectionToken<StorageFileUrlGetterFn>('STORAGE_URL');
export const STORAGE_FILE_DOWNLOAD_URL_GETTER = new InjectionToken<StorageFileUrlGetterFn>(
  'STORAGE_FILE_DOWNLOAD_URL_GETTER',
);
